import InvestmentDetailsForm from "./InvestmentDetailsForm";

export default InvestmentDetailsForm;
